import React from "react";
import Layout from "../Component/Layout";
import Form from "../Component/Form";
import TransactionList from "../Component/TransactionList";

function Home() {
  return (
    <Layout>
      <Form />
      <TransactionList />
    </Layout>
  );
}

export default Home;
